export const TREASURY_FORM_TYPES = {
  CASH_CLOSURE: "CASH_CLOSURE",
  FUND_ACCOUNTABILITY: "FUND_ACCOUNTABILITY",
  COLLECTION: "COLLECTION",
  OPERATIONAL_CONTROL: "OPERATIONAL_CONTROL",
  CUSTOM: "CUSTOM",
};

export const TREASURY_FORM_TYPE_OPTIONS = [
  { value: "CASH_CLOSURE", label: "Cierre de caja" },
  { value: "FUND_ACCOUNTABILITY", label: "Rendición de fondos" },
  { value: "COLLECTION", label: "Recaudación" },
  { value: "OPERATIONAL_CONTROL", label: "Control operativo" },
  { value: "CUSTOM", label: "Personalizado" },
];

export const TREASURY_FORM_STATUSES = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const TREASURY_FORM_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Activo" },
  { value: "ARCHIVED", label: "Archivado" },
];

export const TREASURY_FIELD_TYPES = {
  SHORT_TEXT: "SHORT_TEXT",
  LONG_TEXT: "LONG_TEXT",
  NUMBER: "NUMBER",
  AMOUNT: "AMOUNT",
  SINGLE_CHOICE: "SINGLE_CHOICE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  IMAGES: "IMAGES",
  CONCEPT_AMOUNT_LIST: "CONCEPT_AMOUNT_LIST",
};

export const TREASURY_FIELD_TYPE_LABELS = {
  SHORT_TEXT: "Texto corto",
  LONG_TEXT: "Texto largo",
  NUMBER: "Número",
  AMOUNT: "Monto",
  SINGLE_CHOICE: "Opción única",
  MULTIPLE_CHOICE: "Opción múltiple",
  IMAGES: "Imágenes",
  CONCEPT_AMOUNT_LIST: "Lista de conceptos y montos",
};

export const TREASURY_FIELD_TYPE_OPTIONS = Object.entries(
  TREASURY_FIELD_TYPE_LABELS
).map(([value, label]) => ({ value, label }));

export const TREASURY_FIELD_USAGES = {
  INFORMATIONAL: "INFORMATIONAL",
  MOVEMENT: "MOVEMENT",
};

export const TREASURY_MOVEMENT_TYPES = {
  INCOME: "INCOME",
  EXPENSE: "EXPENSE",
};

export const TREASURY_FIELD_USAGE_LABELS = {
  INFORMATIONAL: "Informativo",
  MOVEMENT: "Movimiento",
};

export const TREASURY_MOVEMENT_TYPE_LABELS = {
  INCOME: "Ingreso",
  EXPENSE: "Egreso",
};

export const TREASURY_SUBMISSION_STATUSES = {
  PENDING: "PENDING",
  IN_REVIEW: "IN_REVIEW",
  APPROVED: "APPROVED",
  CANCELLED: "CANCELLED",
};

export const TREASURY_SUBMISSION_STATUS_LABELS = {
  PENDING: "Sin respuesta",
  IN_REVIEW: "En revisión",
  APPROVED: "Aprobado",
  CANCELLED: "Cancelado",
};

export const TREASURY_SUBMISSION_STATUS_OPTIONS = [
  { value: "IN_REVIEW", label: "En revisión" },
  { value: "APPROVED", label: "Aprobado" },
  { value: "CANCELLED", label: "Cancelado" },
];
